// extracted by mini-css-extract-plugin
module.exports = {"container":"_1dQe5___VideoPlayer-module__container","story":"_9xWk____VideoPlayer-module__story"};